import React from "react";
import { RadialGauge } from "react-canvas-gauges";

const CustomGauge = ({ value, max, label, unit }) => {
  return (
    <div className="container" style={{ textAlign: "center", width: "140px" }}>
      <RadialGauge
       width={130}  
  height={130}
        units={unit}
        title={label}
        value={value}
        minValue={0}
        maxValue={max}
        majorTicks={["0", `${max / 4}`, `${max / 2}`, `${(3 * max) / 4}`, `${max}`]}
        minorTicks={5}
        strokeTicks={true}
        highlights={[{ from: 0, to: max, color: "rgba(0, 0, 0, 0.5)" }]}
        colorPlate="#0d1117"
        colorMajorTicks="#aaa"
        colorMinorTicks="#888"
        colorTitle="#fff"
        colorUnits="#ccc"
        colorNumbers="#eee"
        colorNeedle="red"
        colorNeedleEnd="red"
        needleType="arrow"
        needleWidth={2}
        borders={true}
        borderShadowWidth={0}
        animationDuration={500}
        animationRule="linear"
        valueBox={true}
      />
    </div>
  );
};

export default CustomGauge;
